import type { Texture } from 'three'

// import { elementToSVG } from 'dom-to-svg-v2'

const resetParentFontFamily = (element: HTMLElement, newFontFamily = '') => {
  if (!(element instanceof HTMLElement))
    throw new Error('The provided element is not a valid HTML element.')

  const parentElement = element.parentElement
  if (!parentElement)
    throw new Error('The provided element does not have a parent element.')

  parentElement.style.fontFamily = 'initial'

  if (newFontFamily)
    parentElement.style.fontFamily = newFontFamily
}

/**
 * convert image to Base64
 * @param url
 * @returns
 */
const convertImageToBase64 = (url: string): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.src = url
    img.crossOrigin = 'Anonymous'
    img.onload = function () {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')!

      canvas.width = img.width
      canvas.height = img.height

      ctx.drawImage(img, 0, 0)

      const dataURL = canvas.toDataURL()

      resolve(dataURL)
    }

    img.onerror = function () {
      resolve(null)
    }
  })
}

/**
 * Convert all images and background images to base64
 * @param element
 * @returns
 */
const convertImageAndBackgroundElements = async (element: HTMLElement) => {
  const images = element.getElementsByTagName('img')
  const allImages = [...Array.from(images), element] as HTMLImageElement[]

  for (const img of allImages) {
    if (img.src)
      img.src = await convertImageToBase64(img.src) as string
  }

  const allElements = element.getElementsByTagName('*')
  for (let i = 0; i < allElements.length + 1; i++) {
    const el = i === allElements.length ? element : allElements[i] as Element & { style: { backgroundImage: string } }
    const background = el.style.backgroundImage || window.getComputedStyle(el).backgroundImage

    if (el.style.backgroundImage !== '') {
      const url = background.replace(/url\((['"])?(.*?)\1\)/gi, '$2')

      el.style.backgroundImage = `url(${await convertImageToBase64(url)})`
    }
  }

  return element
}

/**
 * create dom texture
 * @param dom
 * @returns
 */
const createDomTexture = (dom: HTMLElement, option: { width?: number; height?: number }) => {
  return new Promise((resolve) => {
    convertImageAndBackgroundElements(dom).then((dom) => {
      dom.style.top = '-1000px'
      dom.style.position = 'absolute'

      document.body.appendChild(dom)
      resetParentFontFamily(dom)

      let { width, height } = option
      if (width !== undefined && height !== undefined) {
        dom.style.width = `${width}px`
        dom.style.height = `${height}px`
      }
      else {
        const rect = dom.getBoundingClientRect()
        width = rect.width
        height = rect.height
      }

      // const svg = elementToSVG(
      //   dom as HTMLElement,
      // ).querySelector('svg')!

      // const svgData = (new XMLSerializer()).serializeToString(svg)

      // const canvas = document.createElement('canvas')
      // const dpr = (window.devicePixelRatio || 1) * 5

      // canvas.width = width * dpr
      // canvas.height = height * dpr

      // const ctx = canvas.getContext('2d')!
      // ctx.scale(dpr, dpr)

      // const img = new Image()
      // const svg2 = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' })
      // const url = URL.createObjectURL(svg2)

      // img.onload = function () {
      //   ctx.drawImage(img, 0, 0, width!, height!)
      //   const texture = new Texture(canvas)
      //   texture.needsUpdate = true

      //   document.body.removeChild(dom)
      //   resolve(texture)
      // }

      // img.onerror = function (e) {
      //   console.log('error', e)
      // }
      // img.src = url
    })
  }) as Promise<Texture>
}

export default createDomTexture